import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const RefreshIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M14 8c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v1l2.57-1.5L8 0v1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7h-1Z" />{' '}
  </IconWrapper>
)

export default RefreshIconSmall
